import React from "react";
import { Form, Table, Popover, OverlayTrigger } from "react-bootstrap";
import Pagination from "react-js-pagination";
// _includes
import { common } from "_helpers";
import { apiServices } from "_api";
import { ExportCSV } from "_includes";
// css
import styles from "../css/Logs.module.css";

class Unsubscription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "process",
      isLoading: false,
      isFilter: false,
      isSelectAll: false,
      isBulkDelete: false,
      isExport: false,
      deleteIds: [],
      columns: 8,
      paging: {
        pageSize: 10,
        pageIndex: 1,
        recordCount: 0,
      },
      filter: {
        CustomerSubscriptionStatusId: 0,
        CustomerName: "",
        Email: "",
        MobileNumber: "",
        DeviceMacAddress: "",
      },
      data: {
        RecordsCount: 0,
        result: [],
        UnsubscribedCount: 0,
        ResubscribedCount: 0
      },
      sData: {
        subscriptionStatusList: []
      }
    };
  }

  componentDidMount = async () => {
    this.loadData();
    this.getSubscriptionStatusList();
  };

  loadData = () => {
    const { paging, filter } = this.state;
    var data = {
      url: "LOGS_UNSUBSCRIPTION_GET_TABLE",
      query:
        "?PageSize=" + paging.pageSize + "&PageIndex=" + (paging.pageIndex - 1),
      body: filter,
    };

    apiServices.call(
      data,
      (response) => {
        if (response.status === 200) {
          response = response.data;
          // add index
          response.Data.map((item, key) => {
            item.serial =
              paging.pageIndex > 1
                ? (paging.pageIndex - 1) * paging.pageSize + ++key
                : ++key;
          });
          // set data
          this.setState({
            status: "success",
            isLoading: false,
            data: {
              RecordsCount: response.RecordsCount,
              result: response.Data,
              UnsubscribedCount: response.UnsubscribedCount,
              ResubscribedCount: response.ResubscribedCount,
            },
          });
        }
      },
      (error) => {
        this.setState({
          status: "error",
          isLoading: false,
          data: {
            RecordsCount: 0,
            result: [],
          },
        });
      },
      (final) => { }
    );
  };

  getSubscriptionStatusList = () => {
    const { sData } = this.state;
    var data = {
      url: "LOGS_UNSUBSCRIPTION_SUBSCRIPTION_STATUS_LIST",
    };

    apiServices.call(
      data,
      (response) => {
        if (response.status === 200) {
          response = response.data
          sData.subscriptionStatusList = response;
          this.setState({ sData });
        }
      },
      (error) => { },
      (final) => { }
    );
  };

  // events
  handlePageChange(pageNumber) {
    const { paging } = this.state;
    if (paging.pageIndex != pageNumber) {
      paging.pageIndex = pageNumber;
      this.setState(
        {
          paging,
          isLoading: true,
        },
        () => {
          this.loadData();
        }
      );
    }
  }

  handleFilter(isFilter) {
    this.setState({
      isFilter,
    });
  }

  filterData = (event) => {
    const { name, value } = event.target;
    const { filter } = this.state;
    filter[name] = value;
    this.setState(
      {
        filter,
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              isLoading: true,
            },
            () => {
              this.loadData();
            }
          );
        });
      }
    );
  };

  handleRefresh() {
    this.setState(
      {
        isLoading: true,
        isBulkDelete: false,
        isFilter: false,
        isBulkDelete: false,
        isSelectAll: false,
        deleteIds: [],
        paging: {
          pageSize: 10,
          pageIndex: 1,
          recordCount: 0,
        },
        filter: {
          CustomerSubscriptionStatusId: 0,
          CustomerName: "",
          Email: "",
          MobileNumber: "",
          DeviceMacAddress: "",
        },
      },
      () => {
        this.loadData();
      }
    );
  }

  render() {
    const {
      status,
      columns,
      data,
      sData,
      paging,
      filter,
      isLoading,
      isFilter,
    } = this.state;

    return (
      <div>
        <div className="contentBox">
          <div className={`${styles.unSubLog} d-flex`}>
            <div className={`${styles.unSubCount} mr-auto`}>
              <h1>{data.UnsubscribedCount}</h1>
              <p>Unsubscribed</p>
            </div>
            <div className={`${styles.reSubCount} text-right`}>
              <h1>{data.ResubscribedCount}</h1>
              <p>Resubscribed</p>
            </div>
          </div>
        </div>
        <div className="contentBox">
          <div className="poTable">
            <div className="d-flex">
              <div className="mr-auto p-2">
                <span className="potableHeadTitle">Unsubscription Log</span>
                {common.isAccess("UNSUBSCRIPTIONLOG_EXPORT") && (
                  <> - <ExportCSV type="logs_unsubscription" name="unsubscription_log" /></>
                )}
              </div>
              <div className="p-2">
                <div className="d-flex">
                  <div className="poTableIcon">
                    <OverlayTrigger
                      trigger="click"
                      placement="left"
                      rootClose={true}
                      overlay={
                        <Popover id="account-filter">
                          <Popover.Title as="h3">Filter List</Popover.Title>
                          <Popover.Content>
                            <Form className="poTableFilter">
                              <Form.Control
                                as="select"
                                name="CustomerSubscriptionStatusId"
                                value={filter.CustomerSubscriptionStatusId}
                                onChange={this.filterData}
                              >
                                <option value="0">Select Status</option>
                                {sData.subscriptionStatusList.map((item, key) => {
                                  return (
                                    <option key={key} value={item.Id}>
                                      {item.Value}
                                    </option>
                                  );
                                })}
                              </Form.Control>
                              <Form.Control
                                type="text"
                                name="CustomerName"
                                placeholder="Customer Name"
                                value={filter.CustomerName}
                                onChange={this.filterData}
                              />
                              <Form.Control
                                type="text"
                                name="Email"
                                placeholder="Email"
                                value={filter.Email}
                                onChange={this.filterData}
                              />
                              <Form.Control
                                type="text"
                                name="MobileNumber"
                                placeholder="Mobile number"
                                value={filter.MobileNumber}
                                onChange={this.filterData}
                              />
                              <Form.Control
                                type="text"
                                name="DeviceMacAddress"
                                placeholder="Device Mac Address"
                                value={filter.DeviceMacAddress}
                                onChange={this.filterData}
                              />
                            </Form>
                          </Popover.Content>
                        </Popover>
                      }
                      onExit={() => this.handleFilter(false)}
                    >
                      {isFilter ? (
                        <img
                          src={common.appIcon("FilterSelect")}
                          className="poc-cp"
                          alt="Filter"
                          onClick={() => this.handleFilter(false)}
                        />
                      ) : (
                          <img
                            src={common.appIcon("FilterIcon")}
                            className="poc-cp"
                            alt="Filter"
                            onClick={() => this.handleFilter(true)}
                          />
                        )}
                    </OverlayTrigger>
                    <img
                      src={common.appIcon("RefreshIcon")}
                      className="poc-cp"
                      alt="Refresh"
                      onClick={() => this.handleRefresh()}
                    />
                  </div>
                </div>
              </div>
            </div>

            {isLoading && (
              <div className="d-flex justify-content-center">
                <span className="poTableFetcher">
                  fetching data please wait...
            </span>
              </div>
            )}

            <div className={isLoading ? "poTableOnLoad" : ""}>
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>CustomerName</th>
                    <th>MobileNumber</th>
                    <th>Email</th>
                    <th>Mac Address</th>
                    <th>Status</th>
                    <th>Timestamp</th>
                  </tr>
                </thead>
                <tbody>
                  {status == "process" ? (
                    <tr className="poTableMsg">
                      <td colSpan={columns}>Loading data please wait...</td>
                    </tr>
                  ) : status == "error" ? (
                    <tr className="poTableMsg">
                      <td colSpan={columns}>
                        There was an error while fetching record.
                  </td>
                    </tr>
                  ) : data.RecordsCount == 0 ? (
                    <tr className="poTableMsg">
                      <td colSpan={columns}>Sorry no record found.</td>
                    </tr>
                  ) : data.result.map((item, key) => {
                    return (
                      <tr key={key}>
                        <td>{item.serial}</td>
                        <td>{item.CustomerName}</td>
                        <td>{item.MobileNumber}</td>
                        <td>{item.Email}</td>
                        <td>{item.DeviceMacAddress}</td>
                        <td>{item.SubscriptionStatus}</td>
                        <td>{item.TimeStamp}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              {data.RecordsCount > 0 && (
                <div className="d-flex">
                  <div className="mr-auto p-2">
                    Total Records: {data.RecordsCount}
                  </div>
                  <div className="p-2">
                    <Pagination
                      itemClass="page-item"
                      linkClass="page-link"
                      activePage={paging.pageIndex}
                      itemsCountPerPage={paging.pageSize}
                      totalItemsCount={data.RecordsCount}
                      pageRangeDisplayed={5}
                      onChange={this.handlePageChange.bind(this)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export { Unsubscription };
